import { createSlice } from '@reduxjs/toolkit'
import createQueryString from 'src/utils/createQueryString'
import axios from '../../api/index'
import { startLoading, stopLoading } from './loadingSlice'
import { failed } from './snackSlice'

export const salesSlice = createSlice({
  name: 'sales',
  initialState: {
    list: [],
    totalHits: 0,
    totalAmount: 0,
  },
  reducers: {
    discountsFetched: (state, { payload }) => payload,
    totalPriceFetched: (state, { payload }) => {
      state.totalAmount = payload
    },
  },
})

export const {
  discountsFetched,
  totalPriceFetched,
} = salesSlice.actions

export default salesSlice.reducer

export const getSalesReport = (data) => (dispatch) => {
  console.log({ data })
  dispatch(startLoading())
  axios.get('Payment', { params: createQueryString(data) })
    .then((res) => {
      dispatch(stopLoading())
      console.log('discountsFetched', res)
      dispatch(discountsFetched({
        list: res.data.data,
        totalHits: res.data.totalHits,
        totalAmount: res.data.meta.totalAmount,
      }))
      // dispatch(totalPriceFetched(res.data.meta.totalAmount))
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('خطا در دریافت گزارش فروش'))
      dispatch(stopLoading())
    })
}
